module.exports = __webpack_public_path__ + "img/847.9251d93e.png";